import PropTypes from 'prop-types';
import { Button } from '@celltrak/ui-components';
import noop from 'lodash/noop';

import { text } from '../../constants';

const CancelButton = ({ onClick }) => (
  <Button id={text.cancel} size={text.mediumSize} onClick={onClick} color="light">
    {text.cancel}
  </Button>
);

CancelButton.propTypes = {
  onClick: PropTypes.func,
};

CancelButton.defaultProps = {
  onClick: noop,
};

export default CancelButton;
